/* AFTER FOUR v53. Native menu, exact filtered Shop All destinations, truthful active state. */
(() => {
  'use strict';
  const selectActive = () => {
    const root = document.getElementById('header-group');
    if (!root) return;
    const path = window.location.pathname.replace(/\/$/, '');
    const filter = new URLSearchParams(window.location.search).get('af_filter');
    const match = (anchor) => {
      let link;
      try {link = new URL(anchor.getAttribute('href'), window.location.href);} catch (_) {return false;}
      const p = link.pathname.replace(/\/$/, '');
      if (path === '/collections/all') {
        if (p !== '/collections/all') return false;
        const candidate = link.searchParams.get('af_filter');
        return filter === 'makhana' || filter === 'edamame' ? candidate === filter : !candidate;
      }
      if (path === '/pages/build-your-own-box') return p === path;
      return false;
    };
    root.querySelectorAll('.menu-list a[href], .menu-drawer__navigation a[href]').forEach((link) => {
      const active = match(link);
      link.classList.toggle('af53-is-current', active);
      if (active) link.setAttribute('aria-current','page');
      else if (link.getAttribute('aria-current') === 'page') link.removeAttribute('aria-current');
    });
  };
  const init = () => {
    selectActive();
    document.addEventListener('click',(event) => {
      if (event.target instanceof Element && event.target.closest('[data-af52-filter],[data-af52-shelf],#header-group a')) {
        window.setTimeout(selectActive,0);
      }
    },{passive:true});
    window.addEventListener('popstate',selectActive);
    document.addEventListener('shopify:section:load',selectActive);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();